import { Box, Divider } from '@mui/material'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { selectSideMenuState } from '../../../store/features/app'
import { selectCurrrentAdminShop } from '../../../store/features/currentBusinessShop'
import { LogoLight } from '../../atoms/Logo'
import { LogoSmDark } from '../../atoms/LogoSm'
import Layout from './Layout'
import CreateInventoryModal from './modals/CreateInventoryModal'
import BrandsCatalog from './Pages/brands'
import CategoriesCatalog from './Pages/categories'
import MainDashboard from './Pages/dashboard'
import Employees from './Pages/employees'
import Expenses from './Pages/expenses'
import Inventory from './Pages/inventory-frozen'
import InventoryLogs from './Pages/inventory_logs/Main'
import Sales from './Pages/sales'
import SalesLogs from './Pages/sales_logs/Main'
import { AccountSettings, GeneralSettings } from './Pages/settings'
import Shops from './Pages/shops'
import UserLogs from './Pages/user_logs/Main'
import SideMenuNavigation from './SideMenuNavigation'



export default function Dashboard() {

    const sideMenuState = useSelector(selectSideMenuState)
    const currentShop = useSelector(selectCurrrentAdminShop)

    useEffect(()=>{

        // (async()=>{

        //    const shops = await Admin.getShops()
        //    console.log(shops);

        // })()
        
    },[])

    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                backgroundColor: 'primary.main',
                display: "flex",
                flexDirection: "row",
            }}
            className="admin-dashboard"
        >
            
            
            <Box
                sx={{
                    backgroundColor: "primary.main",
                    flex: sideMenuState === "full" ? 0.9 : 0.1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingY: ".5rem"
                    }}
                >
                    {
                        sideMenuState==="full" ? <LogoLight /> : (

                            <div 
                                style={{
                                    width: "30px",
                                    height: "30px"
                                }}
                            >
                                <LogoSmDark />
                            </div>

                        )
                    }
                </Box>
                <Divider sx={{backgroundColor: 'rgba(255, 255, 255, 0.1)'}} />

                <Box
                    sx={{
                        width: "100%",
                        flex: 10,
                        overflowY: "auto"
                    }}
                >
                    <SideMenuNavigation />

                </Box>

            </Box>

            <Layout >
                {
                    currentShop ? (
                        <>
                            <Switch>
                                <Route path={`/${currentShop.name}`} exact component={MainDashboard} />
                                <Route path={`/${currentShop.name}/sales:inventory`} exact component={Sales} />
                                <Route path={`/${currentShop.name}/expenses`} exact component={Expenses} />
                                <Route path={`/${currentShop.name}/inventory:inventoryID`} exact component={Inventory} />
                                <Route path={`/${currentShop.name}/employees`} exact component={Employees} />
                                <Route path={`/${currentShop.name}/user-logs`} exact component={UserLogs} />
                                <Route path={`/${currentShop.name}/inventory-logs`} exact component={InventoryLogs} />
                                <Route path={`/${currentShop.name}/sales-logs`} exact component={SalesLogs} />
                                <Route path={`/${currentShop.name}/general-settings`} exact component={GeneralSettings} />
                                <Route path={`/${currentShop.name}/account-settings`} exact component={AccountSettings} />
                                <Route path={`/${currentShop.name}/brands`} exact component={BrandsCatalog} />
                                <Route path={`/${currentShop.name}/categories`} exact component={CategoriesCatalog} />
                                <Route exact render={()=><Redirect to={`/${currentShop.name}`} />} />
                            </Switch>
                        </>
                    ):(
                        <>
                            <Route exact path="/" component={Shops} />
                            <Route exact render={()=><Redirect to='/' />} />
                        </>
                    )
                }
            </Layout>
            
            <CreateInventoryModal />

        </Box>
    )
}
